import styled from 'styled-components';

export const ContentTotalizadorIcms = styled.div`
  display: flex;
  align-items: center;
  gap: 2.8125rem;

  span {
    display: flex;
    gap: 0.3125rem;
  }
`;
